
'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const PopinManager = require('./../../../../services/popin');

const Mediator = require('./../../../../core/mediator');
const container = require('./../../../../core/container');
const Translator = require('./../../../../core/translator');

const Menu = require('./../../../../services/structure/menu/desktop');
const zone = require('./../../../../services/structure/zone');
const OverlayMenu = require('./../../../../services/overlay/menu');
const sortItems = require('./../../../../services/sortMenu');

const PopinBtnTpl = require('./template/button.popin.hbs');
const ZoneBtnTpl = require('./template/button.layer.hbs');

let items = [];
let popin;

const createButtons = function(itemTpl, $container, config) {
    let $item;
    items = sortItems(items);

    _.forEach(items, function(item) {
        $item = item.tpl || jQuery(itemTpl({'name': Translator.translate(item.name)}));
        $item.publish('menu:my_account:' + item.name +':click', config);
        $container.append($item);
    });

    return $container;
};

module.exports.onUpdateFinish = () => {
    let popin = PopinManager.createPopin({
        'title': Translator.translate('update_finish_title'),
        'minHeight': 50,
        'buttons': [
            {
                class: 'popin popin-ok',
                text: Translator.translate('submit'),
                click: function() {
                    popin.hide();
                },
            },
        ],
    });

    popin.setContent(`<p>${Translator.translate('update_finish_message')}</p>`);

    popin.display();
};

module.exports.onClick = function() {
    zone.hidePanels();

    let $secondaryNav = jQuery('#cloud-nav-secondary');
    let $accountBtn = $secondaryNav.find('.btn-my-account:first');

    items = [];

    Mediator.publish('menu:my_account:ready', items);

    if(container.get('isMobile')) {
        let $container = jQuery('<ul class="cloud-list list-unstyled"></ul>');

        zone.setSmallPanel(Translator.translate('my_account'), createButtons(ZoneBtnTpl, $container));
    } else {
        let $container = jQuery('<div></div>');
        popin = PopinManager.createPopin({
          'classes': {
            'ui-dialog': 'cloud-dialog cloud-dialog-popover cloud-dialog-popover-left account-popin',
          },

            'position': {my: 'left center', at: 'right+20 top-5', of: $accountBtn},
            'width': 250,
            'modal': false,
            'height': 40*items.length,
            'draggable': false,
            'onClick': function() {
                popin.hide();
            },
        });

        container.set('prevent-hide-toolbar', true);

        OverlayMenu.show({
            'onClick': popin.hide.bind(popin),
            'isHideable': true,
        });

        popin.on('close', function() {
            Menu.unFocus();
            OverlayMenu.hide();
            container.set('prevent-hide-toolbar', false);
        });

        let $arrow = jQuery('<span class="arrow"></span>');
        $arrow.css('left', '-5px');
        $arrow.css('bottom', '14px');
        popin.rootElement.parent().append($arrow);

        popin.setContent(createButtons(PopinBtnTpl, $container, {
            'popin': popin,
        }));

        popin.display();


        jQuery(document).on('scroll.scroll_logout', function() {
            popin.hide();
        });
    }
};

module.exports.close = () => {
    if (popin) {
        popin.hide();
        popin = null;
    }
};
